import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';

type Instance = { brand_name: string; brand_logo_url: string | null };

export function Brand({ logo = false }: { logo?: boolean }) {
  const { data } = useQuery({
    queryKey: ['instance'],
    queryFn: () => apiFetch<Instance>('/api/v1/instance'),
    staleTime: Infinity,
  });
  return <>{logo && data?.brand_logo_url && <img src={data.brand_logo_url} alt="" className="mx-auto mb-4 h-16 w-16 object-contain" />}{data?.brand_name ?? 'Passport'}</>;
}
